const publicRoutes = ['/direct-outreach']

export const isPublicRoute = (path: string) => {
  return publicRoutes.some((route) => path.startsWith(route))
}
